import { ca } from '@cian/analytics';

export function trackNavigateToDealForm(navigatedFromSection: 'main' | 'type' | 'price' | 'basement') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Click',
    label: `GoToForm/${navigatedFromSection}`,
  });
}
